<template>
    <v-card>
        <v-toolbar dark color="primary" flat height="48">
            <v-icon left>share</v-icon><v-toolbar-title> Share</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-8 pb-6">
            <v-row>
                <v-col align="center" offset="1" cols="5">
                    <v-btn fab color="secondary" elevation="0" @click="download_pdf">
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-col>
                <v-col align="center" cols="5">
                    <v-btn fab color="secondary" elevation="0" @click="link_dialog = true">
                        <v-icon>link</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col align="center" offset="1" cols="5">
                    <span class="text-subtitle-2">PDF</span>
                </v-col>
                <v-col align="center" cols="5">
                    <span class="text-subtitle-2">Link</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-snackbar app v-model="error">
            <v-icon left>error</v-icon>
            {{ error_msg }}
        </v-snackbar>
        <v-dialog v-model="link_dialog" max-width="700">
            <v-card class="pt-5 pl-7 pr-7 ma-0">
                <v-row no-gutters>
                <v-text-field
                  single-line
                  label="link"
                  dense
                  :value="link"
                  class="mt-2 mr-0 ml-0 mb-0 pa-0"
                  outlined
                  prepend-inner-icon="link"
                  readonly
                  @focus="$event.target.select()"
                  @click="$event.target.select()"
                />
                <v-select
                  style="max-width: 100px"
                  class="pl-3"
                  v-model="lifetime"
                  :items="lifetime_options"
                  append-icon="timer"
                />
                </v-row>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

import axios from 'axios'

export default {
    name: 'ShareDialog',
    data () {
        return {
            error: false,
            error_msg: '',
            link_dialog: false,
            lifetime_options: [
                {text: '1 Day', value: 60 * 60 * 24},
                {text: '1 Week', value: 60 * 60 * 24 * 7},
                {text: '1 Month', value: 60 * 60 * 24 * 365 / 12},
                {text: '1 Year', value: 60 * 60 * 24 * 365},
            ],
            lifetime: 60 * 60 * 24,
            link: null
        }
    },
    watch: {
        async lifetime (newVal, oldVal) { // eslint-disable-line no-unused-vars
            await this.update_link();
        }
    },
    methods: {
        async generate_token (lifetime) {
            try {
                var r = await axios.post(
                    `${this.$store.getters['teacher/api_endpoint']}/generate_token`,
                    {lifetime: lifetime}
                );
                return r.data.token;
            } catch (e) {
                this.error_msg = "Error generating secure token";
                this.error = true;
            }
        },
        async download_pdf () {
            var token = await this.generate_token(15);
            var print_base = this.$store.getters['teacher/print_base'];
            var url = `${print_base}${token}`;
            window.open(url);
        },
        async update_link () {
            var token = await this.generate_token(this.lifetime);
            this.link = `https://${window.location.host}/view/${token}`
        },
    },
    async mounted () {
        await this.update_link();
    }
}
</script>
